export class AdvisoryFeeUtil {
	/**
	 * Takes a percentage value and removes the fee value. Divides the fee by 365 if not annualised.
	 * @returns the value with the fee deducted
	 */
	public static calculateValueWithScenarioAdvisoryFee(value: number, customAdvisoryFee: number, isAnnualised: boolean): number {
		return value - (isAnnualised ? (customAdvisoryFee || 0) : (customAdvisoryFee || 0) / 365);
	}
}
